import React, { useContext, useEffect, useRef, useState } from 'react';
import { ApiContext } from '@api/api';
import { SelectButton } from 'primereact/selectbutton';
import { LovWithoutIdDTO, ShipmentStateCodeEnum } from '@api/ringil-api.v2';
import { setOrRemoveDataTestId, TestIdElement, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  code: ShipmentStateCodeEnum;
  onChange: (code: ShipmentStateCodeEnum) => void;
  required?: boolean;
  disabled?: boolean;
  dataTestIdPrefix?: string;
  // Opt-in: when the caller already has the LOV, pass it to avoid a duplicate fetch.
  options?: LovWithoutIdDTO[];
}

const InputShipmentStatus: React.FC<ComponentProps> = ({ code, onChange, required = false, disabled = false, dataTestIdPrefix, options }) => {
  const { lovShipmentStateStatus } = useContext(ApiContext);
  const [fetched, setFetched] = useState<LovWithoutIdDTO[]>([]);
  const shipmentStateStatuses = options ?? fetched;
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (options) return; // caller supplied options → skip the BE call
    lovShipmentStateStatus(d => {
      setFetched(d);
    });
  }, [options]);

  useEffect(() => {
    const buttons = Array.from(wrapperRef.current?.querySelectorAll?.('.p-selectbutton .p-button') ?? []) as TestIdElement[];

    buttons.forEach((button, index) => {
      const option = shipmentStateStatuses[index];
      const slugValue = option?.code || option?.name || '';
      setOrRemoveDataTestId(button, dataTestIdPrefix ? `${dataTestIdPrefix}-${toTestIdSlug(slugValue)}` : undefined);
    });
  }, [dataTestIdPrefix, shipmentStateStatuses]);

  return (
    <div ref={wrapperRef}>
      <SelectButton
        options={shipmentStateStatuses}
        optionValue={'code'}
        optionLabel={'name'}
        value={code}
        disabled={disabled}
        onChange={e => {
          if (e.value != null || !required) onChange(e.value);
        }}
      />
    </div>
  );
};

export default InputShipmentStatus;
